import { mapToMenuWithDivider } from 'common/helpers/common.helper';
import { IAddressSuggestion } from 'entities/Address/Address.models';

export const getAddressSuggestionOptions = (addressSuggestionList: IAddressSuggestion[]) => {
  return mapToMenuWithDivider(addressSuggestionList.map((address) => ({ label: address.name, value: address.name })));
};
